import { render, staticRenderFns } from "./PartDesignControl.vue?vue&type=template&id=39339414&scoped=true"
import script from "./PartDesignControl.vue?vue&type=script&lang=ts"
export * from "./PartDesignControl.vue?vue&type=script&lang=ts"
import style0 from "./PartDesignControl.vue?vue&type=style&index=0&id=39339414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39339414",
  null
  
)

export default component.exports